import { stats } from "@/mocks/community";

const quickTags = ["娱乐八卦", "科技热评", "生活段子", "游戏吃瓜", "社会观察"];

export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20cream%20and%20soft%20coral%20orange%20abstract%20flowing%20shapes%2C%20playful%20community%20social%20illustration%20with%20gentle%20grain%20texture%2C%20modern%20minimal%20web%20banner%2C%20bright%20airy%20evening%20glow%2C%20no%20text&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="吃瓜17社区 话题讨论背景插画"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/55 via-background-50/45 to-background-50" aria-hidden="true"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-32 pb-12 md:pt-44 md:pb-20 w-full">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
            <i className="ri-fire-fill text-sm" aria-hidden="true"></i>
            今日已有 1.2w+ 条新讨论
          </span>
          <h1 className="mt-5 text-3xl md:text-5xl leading-tight md:leading-snug font-black text-foreground-950">
            上吃瓜17，看懂<b className="text-primary-600 font-black">每一个热门话题</b>的来龙去脉
          </h1>
          <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
            这里是吃瓜17社区讨论区，汇聚吃瓜17论坛帖子与热门话题，实时更新吃瓜17评论与群聊精华。想听网友对每个事件的看法与互动，进入社区就能参与讨论、围观最新帖子。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#board"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-base font-semibold whitespace-nowrap transition-colors"
            >
              <i className="ri-message-3-line text-lg" aria-hidden="true"></i> 逛逛吃瓜广场
            </a>
            <a
              href="#join"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50/90 border border-background-300 text-foreground-800 hover:bg-background-100 text-base font-semibold whitespace-nowrap transition-colors"
            >
              <i className="ri-user-add-line text-lg" aria-hidden="true"></i> 免费加入社区
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500 mr-1 whitespace-nowrap">大家都在聊：</span>
            {quickTags.map((t) => (
              <a
                key={t}
                href="#board"
                className="px-3 py-1 rounded-full bg-background-100/80 border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 text-xs whitespace-nowrap transition-colors"
              >
                {t}
              </a>
            ))}
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 max-w-3xl">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-background-50/80 border border-background-200/80 px-4 py-4 text-center"
            >
              <dt className="order-2 mt-1 text-xs text-foreground-500">{s.label}</dt>
              <dd className="order-1 text-2xl md:text-3xl font-black text-primary-600">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}